import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
export default new Router({
    //去掉#号  但是需要后台配合
    // mode:'history',
    routes: [
        //首页
        {
            path: '/',
            name: 'index',
            component: resolve => require(['@/pages/index/index'], resolve),
        },
        //调试
        {
            path: '/test',
            name: 'test',
            component: resolve => require(['@/pages/index/test'], resolve)
        },
        //博物馆列表页
        {
            path: '/list',
            name: 'list',
            component: resolve => require(['@/pages/list/list'], resolve),
        },
        //新增展项分类列表
        {
            path: '/listmenus',
            name: 'listmenus',
            component: resolve => require(['@/pages/list/listmenus'], resolve),
        },
        //博物馆列表详情页 画册列表
        {
            path: '/list/detail',
            name: 'listxq',
            component: resolve => require(['@/pages/list/detail'], resolve)
        },
        //新之航、设备库详情
        {
            path: '/list/edetail',
            name: 'listexq',
            component: resolve => require(['@/pages/list/edetail'], resolve)
        },
        //画册图片列表页 （幻灯 和 按照时间排列 ）
        {
            path: '/picture',
            name: 'picture',
            component: resolve => require(['@/pages/picture/picture'], resolve)
        },
        //画册图片详情页
        {
            path: '/picture/detail',
            name: 'picturexq',
            component: resolve => require(['@/pages/picture/detail'], resolve)
        },
        //登录页面
        {
            path: '/system/login',
            name: 'login',
            component: resolve => require(['@/pages/system/login'], resolve)
        },
        //后台博物馆页面 + 新增
        {
            path: '/system/museum/museum',
            name: 'museumadd',
            component: resolve => require(['@/pages/system/museum/museum'], resolve)
        },
        //后台博物馆页面 + 博物馆列表
        {
            path: '/system/museum/museumlist',
            name: 'museumlist',
            component: resolve => require(['@/pages/system/museum/museumlist'], resolve)
        },
        //新之航后台展馆页面 + 博物馆列表
        {
            path: '/system/museum/newairmuseumlist',
            name: 'newairmuseumlist',
            component: resolve => require(['@/pages/system/museum/newairmuseumlist'], resolve)
        },
        //设备库后台页面 + 列表
        {
            path: '/system/museum/equipmuseumlist',
            name: 'equipmuseumlist',
            component: resolve => require(['@/pages/system/museum/equipmuseumlist'], resolve)
        },
        //后台相册页面 + 新增
        {
            path: '/system/album/album',
            name: 'albumadd',
            component: resolve => require(['@/pages/system/album/album'], resolve)
        },
        //后台相册页面 + 相册页面列表
        {
            path: '/system/album/albumlist',
            name: 'albumlist',
            component: resolve => require(['@/pages/system/album/albumlist'], resolve)
        },

        //后台展项页面 + 展项页面列表
        {
            path: '/system/album/equitlist',
            name: 'equitlist',
            component: resolve => require(['@/pages/system/album/equitlist'], resolve)
        },
        //相册图片页面
        {
            path: '/system/pic/one',
            name: 'one',
            component: resolve => require(['@/pages/system/pic/one'], resolve)
        },
        //图片上传页面
        {
            path: '/system/pic/update',
            name: 'update',
            component: resolve => require(['@/pages/system/pic/update'], resolve)
        },
        //博物馆，相册搜索页
        {
            path: '/list/searchonet',
            name: 'searchonet',
            component: resolve => require(['@/pages/list/searchonet'], resolve)
        },
        {
            path: '/list/searchone',
            name: 'searchone',
            component: resolve => require(['@/pages/list/searchone'], resolve)
        },
        //相册搜索页
        {
            path: '/list/searchtwo',
            name: 'searchtwo',
            component: resolve => require(['@/pages/list/searchtwo'], resolve)
        },

        //pdf
        {
            path: '/list/pdf',
            name: 'pdf',
            component: resolve => require(['@/pages/list/pdf'], resolve)
        },

        //用户管理
        {
            path: '/setup/user/user',
            name: 'user',
            component: resolve => require(['@/pages/setup/user/user'], resolve)
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js